<template>
  <label v-bind="$attrs">
    <slot>
      {{ convertedLabel }}
    </slot>
  </label>
</template>

<script>
export default {
  name: 'MpxLabel',
  props: {
    prefix: {
      type: String,
      default: 'mpx-',
    },
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    convertedLabel() {
      return this.label ? this.label[0].toUpperCase() + this.label.slice(1) : null;
    },
  },
};
</script>
